define.alias("shared/components/shared/publish/index", "preview-grid/components/shared/publish/index");